(function ($, window, document) {
  function localeToLang (lang) {
    if (lang && lang.match(/[a-z]{2}-[a-z]/gi)) {
      return lang.split('-')[0];
    }
    return lang;
  }

  function getCurrentLanguage () {
    var currentLanguage = $('html').prop('lang') || 'fi';
    return localeToLang(currentLanguage);
  }

  function getPreferredLanguage () {
    return window.Cookies.get('preferredlanguage');
  }

  function setPreferredLanguage (lang) {
    var domain = window.location.hostname.substring(
      window.location.hostname.indexOf('.'),
    );
    window.Cookies.set('preferredlanguage', lang, {
      expires: 365,
      path: '/',
      domain: domain,
      secure: true
    });
  }

  function checkPreferredLanguage () {
    var currentLanguage = getCurrentLanguage();
    var preferredLanguage = getPreferredLanguage();

    if (currentLanguage && preferredLanguage
        && currentLanguage !== preferredLanguage) {
      setPreferredLanguage(currentLanguage);
    }
  }

  function onLanguageChange (event) {
    event.preventDefault();
    var preferredLanguage = getPreferredLanguage();
    var locale = $(this).data('lang') || 'fi';
    var lang = localeToLang(locale);
    var href = $(this).prop('href');

    if (lang !== preferredLanguage) {
      setPreferredLanguage(lang);
    }

    window.location.replace(href);
  }

  function onDOMContentLoaded() {
    if (!window.Cookies) {
      console.warn('Cookies plugin not available');
      return;
    }
    // Bind language change to language switcher links
    $('#js-select-language').on('click', 'a', onLanguageChange);
    // Check preferred language
    checkPreferredLanguage();
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})(jQuery, window, document);
